<script>
export default {
  name: "OrgFinancesHarvestedBatchOutComesPayExportInvoiceButton",
  template: `
    <gray-button
      v-if="paid"
      @click.prevent="payOrgInvoice()"
      icon="fa-solid fa-ban"
      label="Marcar no pagada"
    />
    <success-button
      v-else
      @click.prevent="payOrgInvoice()"
      icon="fa-solid fa-check-double"
      label="Marcar pagada"
    />
  `,
  props: {
    paid: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    payOrgInvoice: function () {
      this.$emit("payOrgInvoice");
    }
  }
};
</script>
